/**
 * Match phase and countdown helpers for MatchCard.
 */

const FIVE_MIN_MS = 5 * 60 * 1000;
const ONE_HOUR_MS = 60 * 60 * 1000;
const LIVE_WINDOW_MS = 90 * 60 * 1000;
/** Countdown visible only within this window before kickoff */
const COUNTDOWN_WINDOW_MS = 12 * 60 * 60 * 1000;

const isWithinLiveWindow = (matchDate, now) => {
  const kickoffMs = new Date(matchDate).getTime();
  if (Number.isNaN(kickoffMs)) return false;
  const elapsed = now.getTime() - kickoffMs;
  return elapsed >= 0 && elapsed <= LIVE_WINDOW_MS;
};

/**
 * @param {string|Date} matchDate
 * @param {object} [result]
 * @param {Date} [now]
 * @returns {'finished' | 'live' | 'upcoming'}
 */
export const getMatchPhase = (matchDate, result, now = new Date()) => {
  const status = result?.matchStatus;

  if (status === 'finished') {
    return 'finished';
  }

  if (status === 'cancelled') {
    return 'upcoming';
  }

  const hasScores =
    result?.homeScore != null && result?.awayScore != null;

  if (status === 'live' && hasScores) {
    return 'live';
  }

  if (status === 'live' && isWithinLiveWindow(matchDate, now)) {
    return 'live';
  }

  if (isWithinLiveWindow(matchDate, now)) {
    return 'live';
  }

  return 'upcoming';
};

/**
 * @param {string|Date} matchDate
 * @param {Date} [now]
 * @returns {string}
 */
export const formatCountdown = (matchDate, now = new Date()) => {
  const kickoff = new Date(matchDate);
  if (Number.isNaN(kickoff.getTime())) return '';

  const diffMs = kickoff.getTime() - now.getTime();
  if (diffMs <= 0 || diffMs > COUNTDOWN_WINDOW_MS) return '';

  if (diffMs < FIVE_MIN_MS) {
    return 'Soon';
  }

  const totalMinutes = Math.floor(diffMs / (60 * 1000));

  if (diffMs >= ONE_HOUR_MS) {
    const hours = Math.floor(totalMinutes / 60);
    const minutes = totalMinutes % 60;
    return minutes > 0 ? `${hours}h:${minutes}m` : `${hours}h`;
  }

  return `${totalMinutes}m`;
};
